import { integrationsService } from '@/services/integrations';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Tenta emitir AGORA, pela integração, um controle que aguardava emissão manual.
 *
 * NÃO lança em erro de negócio — devolve o envelope `{ success, error }` para o
 * modal de confirmação exibir a mensagem inline, no mesmo padrão da emissão
 * manual. Uma tentativa que FALHA na emissão ainda é `success: true`: o desfecho
 * vem em `data.outcome`.
 */
export function useReleaseToAutomaticEmission() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (policyId: string) =>
      integrationsService.releaseToAutomaticEmission(policyId),
    onSuccess: (response, policyId) => {
      if (!response.success) return;

      queryClient.invalidateQueries({
        queryKey: ['integration-details', policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
      // Emitida, a apólice passa a existir: proposta e listagens mudam de status.
      queryClient.invalidateQueries({ queryKey: ['proposal', policyId] });
      queryClient.invalidateQueries({ queryKey: ['proposals'] });
      queryClient.invalidateQueries({ queryKey: ['policies'] });
    },
  });
}
